import React from 'react';
import ReactDOM from 'react-dom';
interface PolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
}
export function PolicyModal({
  isOpen,
  onClose,
  title
}: PolicyModalProps) {
  if (!isOpen) return null;
  const getContent = () => {
    if (title === 'Política de Privacidad') {
      return <>
          <p className="mb-4" data-id="element-109">
            En Mascota Genial®, valoramos y respetamos tu privacidad. Toda la
            información que compartas con nosotros será utilizada únicamente
            para procesar tu compra, mejorar tu experiencia y enviarte
            información relacionada con nuestros productos o servicios.
          </p>

          <p className="mb-4" data-id="element-110">
            No compartimos, vendemos ni cedemos tus datos personales a terceros
            sin tu consentimiento, salvo cuando sea necesario para procesar
            pagos, entregar contenido digital o cumplir con obligaciones
            legales.
          </p>

          <p className="mb-4" data-id="element-111">
            Al utilizar este sitio web, aceptas el tratamiento de tus datos
            conforme a esta política. Puedes solicitar la modificación o
            eliminación de tu información escribiéndonos a nuestro canal de
            contacto oficial.
          </p>
        </>;
    }
    if (title === 'Términos y Condiciones') {
      return <>
          <p className="mb-4" data-id="element-112">
            Al adquirir este producto digital, aceptas que se trata de un
            contenido educativo e informativo destinado a apoyar el bienestar y
            entrenamiento de tu mascota.
          </p>

          <p className="mb-4" data-id="element-113">
            Este material no reemplaza la evaluación de un veterinario o etólogo
            clínico, especialmente en casos de agresividad severa, ansiedad
            extrema o condiciones neurológicas.
          </p>

          <p className="mb-4" data-id="element-114">
            Debido a la naturaleza digital del producto, una vez realizada la
            compra no se realizan devoluciones, salvo que la legislación
            aplicable indique lo contrario.
          </p>

          <p className="mb-4" data-id="element-115">
            El acceso al contenido es personal e intransferible. Queda prohibida
            su reproducción, distribución o reventa sin autorización expresa.
          </p>
        </>;
    }
    return <p data-id="element-116">No hay contenido disponible.</p>;
  };
  return ReactDOM.createPortal(<div className="fixed inset-0 z-[9999]" data-id="element-117">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} data-id="element-118" />

      <div className="
          absolute
          left-1/2
          top-1/2
          w-[calc(100vw-2rem)]
          max-w-lg
          -translate-x-1/2
          -translate-y-1/2
          max-h-[90vh]
          overflow-y-auto
          rounded-2xl
          bg-white
          p-5
          md:p-6
          shadow-2xl
        " data-id="element-119">
        <button onClick={onClose} className="absolute top-3 right-4 text-xl text-slate-500 hover:text-slate-800 transition-colors" aria-label="Cerrar modal" data-id="element-120">
          ✕
        </button>

        <h2 className="text-xl md:text-2xl font-bold text-[#1D1D1F] mb-5 pr-8" data-id="element-121">
          {title}
        </h2>

        <div className="text-sm md:text-base text-slate-700 leading-relaxed text-left" data-id="element-122">
          {getContent()}
        </div>
      </div>
    </div>, document.body);
}